import Image from 'next/image';

interface Props {
    className?: string;
    width?: number;
    height?: number;
}

const Loader = ({ className = '', width, height }: Props) => {
    return (
        <Image
            className={'mx-auto ' + className}
            src={'/icons/loader.svg'}
            alt={''}
            width={width || 40}
            height={height || 40}
        />
    );
};

export default Loader;
